export default __webpack_public_path__ + "maps-examples-building-extrusions-1200-5f2c3037fe41a2cd85e27355bc9df380.webp";